import {ISeAvailabilities, Prestation, Transport} from "@/types/index"
import { WiypResponse } from "@/types/responses"
import getAcceptChildren from "../../logic/getAcceptChildren"

type DatesType = {
	BeginDate?: string
	EndDate?: string
}
const dates: DatesType = {}

interface IWiypFee {
	id: string;
	price: number;
	type: string;
}

export interface IStoreState  {
    language: string | null;
    liheData: any; // Replace any with a more specific type if known
    content: any; // Replace any with a more specific type if known
    feature: any; // Replace any with a more specific type if known
    initialPrestationsArray: any[]; // Define the array element type if possible
    initialPrestationsMap: Record<string, any>; // Specify the value type if known
    packageComposition: Map<any, any>; // Define key and value types if possible
    dates: any; // Specify a more accurate type if possible, like Date or string
	skipass: number | null;
    packCode: string;
    packageId: string;
    currentPackCode: string;
    availablePackageCodeWiyp: { liheId: string, codePackage: string, prestId: string, maxPromo: number, skipass: number | undefined }[]; // array of objects with shape: { liheId: string, codePackage: string, prestId: string, maxPromo: number, skipass: number | undefined }
    participants: number[];
    season: any | null; // Define more specifically if possible

    selectedPrestIds: Record<string, number>;

    prestMaps: {
		prices: ISeAvailabilities
		seAvailabilities: ISeAvailabilities
	};

    transportCheckbox: boolean;

    loading: boolean;
    productUnavailable: boolean;
    datepickerOpen: string;
    participantsDropdownOpen: boolean;
    packagesMobileDropdownOpen: boolean;
    bodyOverflowHidden: boolean;

    prestationsLoaded: boolean;
    scrolledToPlanning: boolean;

    selectDropdownOpen_prestId: string;
    selectDropdownOpen_location: string;

    errorMessageOpen: string;

    scrollToPrestationFired: boolean;

    checkedNeedToPreselectPrestations: boolean;

    quoteRequestsFinishedLoading: boolean;
    lastQuotesRequestTimestamp: Date | null;

    screenType: any | null; // Define more specifically if possible
    averageRatingPerLihe: number;
    reviewNumberPerLihe: string;
    calledPrice: boolean;
    selectedFlexTypes: {
        flex: number;
        nonflex: number;
    };
    skiPassDays: Record<string, number>; // Dynamic record of skipass days
    selectedPrestIdsFusion: Set<any>;
	isWiypActive: boolean;
	wiypFees: IWiypFee[];	
	firstLoad: boolean;
	activePrestations: null | Array<string>;
	prestationsFromCatalog: null | Array<Prestation>;
	flightOrigins: string[];
	flightOrigin: string | null;
	transportationSelected: boolean;
	acceptChildren: boolean;
	wiypCall: Record<string, Record<string, Record<string, Record<string, WiypResponse>>>>; // key: familyComposition, then origin, then packageCode, then packageId, value: WiypResponse
	wiypDefaultFlightOrigin: string | null;

	// transport
	transport: Transport | null;
}

const state: IStoreState = {
	language: document.getElementsByTagName("html")[0].getAttribute("lang"),
	liheData: window.lihe,
	content: window.content,
	feature: window.feature,
	initialPrestationsArray: window.lihe.prestations || [], // array with all prestations, for e.g. 20 in total
	initialPrestationsMap: {},
	packageComposition: new Map(),
	dates,
	packCode: "",
	packageId: "",
	currentPackCode: "",
	availablePackageCodeWiyp: [] as { liheId: string, codePackage: string, prestId: string, maxPromo: number, skipass: number | undefined }[],
	participants: [18, 18],
	season: null,

	selectedPrestIds: {}, // key: prestRef; value: number of prestations

	// responses: {
	//     quotePrices: {},
	//     seAvailabilities: {},
	// },

	prestMaps: {
		prices: {} as ISeAvailabilities,
		seAvailabilities: {} as ISeAvailabilities,
	},
	transportCheckbox: false,

	loading: true,
	productUnavailable: false,
	datepickerOpen: "", // valid entries: "start" and "end"; everything else means it's closed
	participantsDropdownOpen: false,
	packagesMobileDropdownOpen: false,
	bodyOverflowHidden: false,

	prestationsLoaded: false,
	scrolledToPlanning: false,

	selectDropdownOpen_prestId: "", // value is prestId
	selectDropdownOpen_location: "", // prestation or prestationPopup

	errorMessageOpen: "",

	scrollToPrestationFired: false, // after page load it fires once and stays as true, preventing additional scrolls

	checkedNeedToPreselectPrestations: false,

	quoteRequestsFinishedLoading: false,
	lastQuotesRequestTimestamp: null,

	screenType: null,
	averageRatingPerLihe: 0,
	reviewNumberPerLihe: "",
	calledPrice: false,
	selectedFlexTypes: {
		flex: 0,
		nonflex: 0
	},
	skiPassDays: {}, // Initialize as empty object to handle any skipass duration
	selectedPrestIdsFusion: new Set(),
	isWiypActive: false,
	wiypFees: [],
	firstLoad: false,
	activePrestations: null,
	prestationsFromCatalog: null,
	skipass: null,
	flightOrigins: [],
	flightOrigin: null,
	transportationSelected: false,
	acceptChildren: getAcceptChildren(window.location.hostname),
	wiypCall: {},
	wiypDefaultFlightOrigin: null,

	// transport
	transport: null,
}

export default state


